 <template>
  <div class="ViewMentora365NotifyList">
    <div class="container-fluid padding-left-3Perc padding-right-2Point5Perc">
      <div class="row padding-Top-1Perc padding-bottom-2Perc">
        <div class="col-md-12 col-lg-12 font-size-12px font-color-dark-red text-align-left" v-if="parseInt(selectedNotifStatus) === 1">Note: Notifications sent in last <b>7 days</b> are listed below.</div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped ">
          <thead>
            <tr v-if="getNotifList.length !== 0">
              <th class="text-align-center text-valign-middle font-size-15px border-right">Notification Title</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Notification Text</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right" v-if="getSelectedNotifType === 0">Schedule TS</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right" v-if="getSelectedNotifType === 1">Sent TS</th>
              <th class="text-align-center text-valign-middle font-size-15px">Action</th>            
            </tr>
          </thead>
          <tbody>
            <tr v-for="notifObj in getNotifList" :key="notifObj.ScheduledNotificationId" v-bind:notifObj="notifObj">
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc col-md-2 col-lg-2">{{notifObj.NotifTitle}}</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc col-md-2 col-lg-2">{{notifObj.NotifText}}</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc col-md-2 col-lg-2 padding-left-0Perc paddding-right-0px" v-if="getSelectedNotifType === 0">{{formatAndShowDate(notifObj.ScheduleTS)}}</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc col-md-2 col-lg-2 padding-left-0Perc paddding-right-0px" v-if="getSelectedNotifType === 1">{{formatAndShowDate(notifObj.SentTS)}}</td>
              <td class="text-align-center padding-Top-1Perc padding-bottom-1Perc col-md-2 col-lg-2">
                <a class="cursor-pointer" @click="actionSubOption($event, 'Users', notifObj)"> Users </a>
                <a class="cursor-pointer" @click="actionSubOption($event, 'Edit', notifObj)" v-if="getSelectedNotifType === 0">| Edit </a>
                <a class="cursor-pointer" @click="actionSubOption($event, 'Cancel_All', notifObj)" v-if="getSelectedNotifType === 0">| Cancel All </a>
              </td>
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <view-users v-if="showUserListOverlay" :userList="notifUserList" :currNotifObj="selectedNotificationObj" :selectedNotifStatus="selectedNotifStatus" @viewOverlay="closeViewUser"></view-users>
  <Update-Schedule-Notification v-if="editUserListOverlay" :selectedCourseMomentObj="getSelectedCourseMomentObj" :currNotifObj="selectedNotificationObj" @viewOverlay="closeEditUser"></Update-Schedule-Notification>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performAction"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <loader></loader>
  </div>
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { notificationService } from '@/server-util/notification-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import ViewUsers from '@/components/notification/m365/ViewUsersOverlay'
import UpdateScheduleNotification from '@/components/notification/m365/UpdateScheduleNotification'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['notifList', 'selectedNotifStatus', 'selectedCourseMomentObj'],
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      isCurrentlyShowingSpinner: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      selectedNotificationObj: null,
      userList: [],
      showUserListOverlay: false,
      editUserListOverlay: false
    }
  },
  methods: {
    closeViewUser (value) {
      this.showUserListOverlay = value.openOverlay
      this.$store.state.isOverlayVisible = false
      if (value.refreshList) {
        this.$emit('refreshNotificationList', true)
      }
    },
    closeEditUser (value) {
      this.editUserListOverlay = value.openOverlay
      this.$store.state.isOverlayVisible = false
      if (value.refreshList) {
        this.$emit('refreshNotificationList', true)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    formatAndShowDate: function (date) {
      if (date === null || date === 'null') {
        return ''
      }
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Course overlay
      this.showConfirmationBox = value
    },
    actionSubOption: function (event, selectedOption, notifObj) {
      this.selectedNotificationObj = notifObj
      switch (selectedOption) {
        case 'Users':
          this.getAllUserList()
          break
        case 'Edit':
          this.editUserListOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'Cancel_All':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to cancel all notification(s) '
          this.postString = 'scheduled on ' + this.formatAndShowDate(this.selectedNotificationObj.ScheduleTS) + '?'
          break
      }
    },
    performAction (value) {
      // AK: Hide Confirmation Box
      this.showConfirmationBox = false
      if (value) {
        switch (this.prefixString) {
          case 'Are you sure you want to cancel all notification(s) ':
            this.cancelAllNotifications()
            break
        }
      }
    },
    cancelAllNotifications: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedNotificationObj.ScheduledNotificationId !== undefined &&
        this.selectedNotificationObj !== null
      ) {
        this.$store.state.isLoading = true
        var objToPass = {
          ScheduledNotificationId: this.selectedNotificationObj.ScheduledNotificationId,
          UserIds: ''
        }
        notificationService
        .deleteScheduledNotification(storeObj.state.access_token, objToPass)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$emit('refreshNotificationList', true)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected NOTIFICATION Object is NULL hence declined DELETE Scheduled Notification OPERATION'
        )
      }
    },
    getAllUserList: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedNotificationObj.ScheduledNotificationId !== undefined &&
        this.selectedNotificationObj !== null
      ) {
        this.$store.state.isLoading = true
        notificationService
        .getUserList(storeObj.state.access_token, this.selectedNotificationObj.ScheduledNotificationId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.userList = responseObj.data
              _this.$store.state.isLoading = false
              if (_this.userList.length === 0) {
                _this.showAlertDialog = true
                _this.errorMsg = 'No user(s) found.'
                _this.showUserListOverlay = false
                return
              }
              _this.showUserListOverlay = true
              _this.$store.state.isOverlayVisible = true
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected NOTIFICATION Object is NULL hence declined DELETE Scheduled Notification OPERATION'
        )
      }
    },
    editAllUserList: function () {
      this.editUserListOverlay = true
      this.$state.store.isOverlayVisible = true
    }
  },
  computed: {
    getSelectedCourseMomentObj: {
      get: function () {
        return this.selectedCourseMomentObj
      }
    },
    getNotifList: {
      get: function () {
        return this.notifList
      }
    },
    getSelectedNotifType: {
      get: function () {
        return parseInt(this.selectedNotifStatus)
      }
    },
    notifUserList: {
      get: function () {
        return this.userList
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader,
    'view-users': ViewUsers,
    'Update-Schedule-Notification': UpdateScheduleNotification
  },
  name: 'ViewMentora365NotifyList'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.ViewMentora365NotifyList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.tdMargin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-left-1Point7Perc
{
	margin-left: 1.7%;
}
 .margin-right-0Point1Perc
{
	margin-right: 0.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.text-align-center {
 text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.imgWidthHeight{
  width:180px; 
  height:110px;
}
.padding-Top-1Perc{
  padding-Top:1%;
}
.padding-top-2Perc {
  padding-top: 2% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color{
  color:#2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.img-background-color {
  background-color: #d4d4d4 !important;
}
.paddding-right-0px{
  padding-right:0%;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.padding-left-3Perc {
  padding-left: 3%;
}
.padding-right-2Point5Perc {
  padding-right: 2.5%;
}
.font-size-12px {
    font-size: 12px !important;
}
.font-color-dark-red {
    color: darkred;
}
.padding-bottom-1Perc {
  padding-bottom:1%;
}
.padding-bottom-2Perc {
  padding-bottom:2%;
}
.text-align-left {
  text-align:left;
}
.padding-left-0Perc {
  padding-left:0%;
}
</style>



// WEBPACK FOOTER //
// src/components/notification/m365/ViewNotifyList.vue